import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide } from "@mui/material";
import { forwardRef, Fragment, useState } from "react";
import { TransitionProps } from "@mui/material/transitions";
import { useTranslation } from "react-i18next";
import { CrossIcon } from "../assets/icons";

interface IProps {
  text: string;
  titleIcon: React.ReactNode;
  yes?: string;
  no?: string;
}

export const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useConfirm = (props: IProps): [() => JSX.Element, () => Promise<unknown>] => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const [promise, setPromise] = useState<any>(null);

  const confirm = () =>
    new Promise((resolve, reject) => {
      setPromise({ resolve });
    });

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  const ConfirmationDialog = () => (
    <Fragment>
      <Dialog
        open={promise !== null}
        TransitionComponent={Transition}
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.15)",
            padding: "24px",
            maxWidth: "320px",
          },
          "& .MuiDialogTitle-root": {
            paddingBottom: "16px",
          },
          "& .MuiDialogContent-root,& .MuiDialogActions-root": {
            padding: 0,
          },
          "& .MuiDialogContent-root": {
            color: "text.fontDarkest",
            textAlign: "center",
            fontSize: "14px",
            fontWeight: 500,
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "text.fontDarkest",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "150%",
          }}
        >
          {props.titleIcon}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            ...(isRTL ? { left: 8 } : { right: 8 }),
            top: 8,
            color: "text.fontLight",
          }}
        >
          <CrossIcon />
        </IconButton>
        <DialogContent>{props.text}</DialogContent>
        <DialogActions
          sx={{
            marginTop: "16px",
            gap: "8px",
            "& .MuiButtonBase-root": {
              margin: 0,
              alignSelf: "stretch",
            },
          }}
        >
          <Button fullWidth onClick={handleCancel}>
            {props.no}
          </Button>
          <Button fullWidth color="secondary" variant="contained" onClick={handleConfirm}>
            {props.yes}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
  return [ConfirmationDialog, confirm];
};

export default useConfirm;
